@file:Suppress(
    "RETURN_VALUE_NOT_USED",
    "RETURN_VALUE_NOT_USED_COERCION",
)

import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlin.Suppress
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import dev.kobwebssr.probe.pages.Collide2Page as _dev_kobwebssr_probe_pages_Collide2Page
import dev.kobwebssr.probe.pages.CollidePage as _dev_kobwebssr_probe_pages_CollidePage
import dev.kobwebssr.probe.pages.EchoPage as _dev_kobwebssr_probe_pages_EchoPage
import dev.kobwebssr.probe.pages.FindingsPage as _dev_kobwebssr_probe_pages_FindingsPage
import dev.kobwebssr.probe.pages.HomePage as _dev_kobwebssr_probe_pages_HomePage
import dev.kobwebssr.probe.pages.HowPage as _dev_kobwebssr_probe_pages_HowPage
import dev.kobwebssr.probe.pages.ShadowedPage as _dev_kobwebssr_probe_pages_ShadowedPage
import dev.kobwebssr.probe.pages.SsrPage as _dev_kobwebssr_probe_pages_SsrPage
import dev.kobwebssr.probe.pages.StatePage as _dev_kobwebssr_probe_pages_StatePage

public fun main() {
    AppGlobals.initialize(mapOf("title" to "Kobweb SSR Probe"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.register(
            "/",
        ) { pageCtx -> 
            _dev_kobwebssr_probe_pages_HomePage()
        }
        ctx.router.register(
            "/collide",
        ) { pageCtx -> 
            _dev_kobwebssr_probe_pages_CollidePage()
        }
        ctx.router.register(
            "/collide2",
        ) { pageCtx -> 
            _dev_kobwebssr_probe_pages_Collide2Page()
        }
        ctx.router.register(
            "/echo",
        ) { pageCtx -> 
            _dev_kobwebssr_probe_pages_EchoPage()
        }
        ctx.router.register(
            "/findings",
        ) { pageCtx -> 
            _dev_kobwebssr_probe_pages_FindingsPage()
        }
        ctx.router.register(
            "/how",
        ) { pageCtx -> 
            _dev_kobwebssr_probe_pages_HowPage()
        }
        ctx.router.register(
            "/shadowed",
        ) { pageCtx -> 
            _dev_kobwebssr_probe_pages_ShadowedPage()
        }
        ctx.router.register(
            "/ssr",
        ) { pageCtx -> 
            _dev_kobwebssr_probe_pages_SsrPage()
        }
        ctx.router.register(
            "/state",
        ) { pageCtx -> 
            _dev_kobwebssr_probe_pages_StatePage()
        }
        ctx.router.registerRedirect("/old", "/ssr")
        ctx.router.registerRedirect("/shadowed", "/ssr")

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("ssr-marker", dev.kobwebssr.probe.pages.SsrMarkerStyle)
        ctx.theme.registerStyle("page", dev.kobwebssr.probe.PageStyle)
        ctx.theme.registerStyle("nav", dev.kobwebssr.probe.NavStyle)
        ctx.theme.registerStyle("nav-link", dev.kobwebssr.probe.NavLinkStyle)
        ctx.theme.registerStyle("lead", dev.kobwebssr.probe.LeadStyle)
        ctx.theme.registerStyle("card", dev.kobwebssr.probe.CardStyle)
        ctx.theme.registerStyle("mono", dev.kobwebssr.probe.MonoStyle)
        dev.kobwebssr.probe.initStyles(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        dev.kobwebssr.probe.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
